import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { AlertController } from 'ionic-angular';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/toPromise';
import { Account } from '../model/account';
import { AppConfig } from '../shared/app.config';
import { ConfigService } from './config';

@Injectable()
export class UserService {

    config: any = {};

    constructor(public http: Http,
                public alertCtrl: AlertController,
                public configService: ConfigService,
                private appConfig: AppConfig) {

        this.config = this.configService.getConfig();
    }

    /**
     * Logs the user in
     * @param {Account} account
     * @returns {Observable<any>}
     */
    doLogin(account: Account): Observable<any> {
        let storedendpoint = JSON.parse(localStorage.getItem('appconfig'));

        let body = {
            username: account.username.trim(),
            password: account.password.trim()
        };

        return this.http.post(storedendpoint.apiendpoint + 'users/login', body).timeout(10000);
    }

    /**
     * Logs the user out
     * @returns {Observable<any>}
     */
    doLogout(): Observable<any> {
        let storedendpoint = JSON.parse(localStorage.getItem('appconfig'));
        let storedToken = localStorage.getItem('nodetoken');

        let headers = new Headers();
        headers.append('X-NODE-TOKEN', storedToken);

        return this.http.get(storedendpoint.apiendpoint + 'users/logout', {headers: headers});
    }

    /**
     * Checks if stored token is still valid
     * @returns {Observable<any>}
     */
    checkValidToken(): Observable<any> {
        return this.appConfig.getCategories()
            .map((results: any) => {
                return {results: results};
            });
    }

    /*
    * Feldnamen umwandeln, da diese teilweise in unterschiedlicher Schreibweise aus regisafe übergeben werden
    * bspw. Subvorgangsverwaltung oder SubVorgangsverwaltung oder SUBVORGANGSVERWALTUNG
    *
    * toLowerCase() bzw. toUpperCase()
    * @param obj -> Object
    * @param type -> 'upper' or 'lower'
    *
    */
    objectKeysChangeCase(obj, type) {

        var result = [];
        var keys = [];

        for (var i = 0; i < obj.length; i++) {
            keys[i] = Object.keys(obj[i]);

            result[i] = {};
            keys[i].map(function (k, v) {
                if (type == 'lower') {
                    result[i][k.toLowerCase()] = obj[i][k];
                } else if (type == 'upper') {
                    result[i][k.toUpperCase()] = obj[i][k];
                }
            });

        }

        return result;
    }

    /**
     * trimArray()
     * entfernt Leerzeichen vom Anfang und Ende eines Array-Elements
     */
    trimArray(arr) {
        for (let i = 0; i < arr.length; i++) {
            arr[i] = arr[i].trim();
        }
        return arr;
    }
}



// WEBPACK FOOTER //
// ./src/providers/user.ts